module.exports = __webpack_public_path__ + "static/media/morakot-percent.339cc449.svg";